<template>
  <div class="faq-section">
    <b-container>
      <b-row>
        <b-col>
          <FaqList
            v-if="faqs.length > 0"
            :faqs="faqs"
          />
          <h4
            v-else
            class="text-center"
          >There are currently no FAQs for this product.</h4>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FaqList from 'components/website/content-lists/faq/0001/faq-list'

export default {
  name: 'faq',
  components: {
    FaqList
  },
  props: {
    faqs: {
      type: Array,
      required: true
    }
  }
}
</script>
